import { Video, Trees, Users, Globe, Palette, Sparkles } from "lucide-react";

export const EVENT_TYPES = ["zoom", "outdoor", "in_person", "hybrid", "workshop", "other"];

export const EVENT_TYPE_META = {
  zoom: {
    label: { tr: "Zoom Eğitimi", en: "Zoom Training" },
    icon: Video,
    tone: "bg-bluefog-200 text-sage-800",
  },
  outdoor: {
    label: { tr: "Açık Hava", en: "Outdoor" },
    icon: Trees,
    tone: "bg-sage-100 text-sage-700",
  },
  in_person: {
    label: { tr: "Yüz Yüze", en: "In Person" },
    icon: Users,
    tone: "bg-cream-200 text-ink",
  },
  hybrid: {
    label: { tr: "Hibrit", en: "Hybrid" },
    icon: Globe,
    tone: "bg-terracotta-50 text-terracotta-500",
  },
  workshop: {
    label: { tr: "Atölye", en: "Workshop" },
    icon: Palette,
    tone: "bg-terracotta-100 text-terracotta-500",
  },
  other: {
    label: { tr: "Diğer", en: "Other" },
    icon: Sparkles,
    tone: "bg-cream-300 text-ink",
  },
};

export function typeLabel(type, lang) {
  const meta = EVENT_TYPE_META[type] || EVENT_TYPE_META.other;
  return meta.label[lang] || meta.label.tr;
}

export function typeIcon(type) {
  return (EVENT_TYPE_META[type] || EVENT_TYPE_META.other).icon;
}

export function typeTone(type) {
  return (EVENT_TYPE_META[type] || EVENT_TYPE_META.other).tone;
}

export function formatDate(iso, lang) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const locale = lang === "en" ? "en-GB" : "tr-TR";
  return d.toLocaleDateString(locale, { day: "2-digit", month: "long", year: "numeric" });
}

export function formatTime(iso, lang) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const locale = lang === "en" ? "en-GB" : "tr-TR";
  return d.toLocaleTimeString(locale, { hour: "2-digit", minute: "2-digit" });
}

export function formatDateTime(iso, lang) {
  const d = formatDate(iso, lang);
  const t = formatTime(iso, lang);
  return t ? `${d} · ${t}` : d;
}

export function isPast(iso) {
  if (!iso) return false;
  const d = new Date(iso);
  return !Number.isNaN(d.getTime()) && d.getTime() < Date.now();
}
